import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import { ServiceDialog } from '../../../../../styling/Styles';
import AnnotationsMechanism from './AnnotationsMechanism/AnnotationsMechanism';
import FlowDataMechanism from './FlowDataMechanism/FlowDataMechanism';
import FunctionsRow from './FunctionsRow';
import CheckActions from './CheckActions';
import AdvancedSelect from './AdvancedSelect/AdvancedSelect';
import AdvancedSelect2 from './AdvancedSelect/AdvancedSelect2';
import DefineServiceParameter from './FlowDataMechanism/DefineServiceParameter';
import { findViolationsAnnotations } from './AnnotationsMechanism/LockFunctions';

const defaultOptionTarget = 'none';

/*
This cοmponent is rendered inside a general edit pop up component. It is responsible to render options to edit flow attributes or
data attributes according to data element that we edit and then updates the options.
*/
const EditPopUpCore = ({
  editor,
  savedPageClicked,
  selectedProject,
  clickedEdit,
  setClickedEdit
}) => {
  const [openAlert, setOpenAlert] = React.useState(false);
  const [displayAnnotationData, setDisplayAnnotationData] = React.useState(false);
  const [displayFlowData, setDisplayFlowData] = React.useState(false);
  const [lock, setLock] = React.useState(false);
  const [target, setTarget] = React.useState('none');
  const [href, setHref] = React.useState('');
  const [targetPageChecked, setTargetPageChecked] = React.useState(false);
  const [hrefChecked, setHrefChecked] = React.useState(false);
  const [newWindowChecked, setNewWindowChecked] = React.useState(false);
  const [functionName, setFunctionName] = React.useState('none');
  const [transitionById, setTransitionById] = React.useState(false);
  const [previousPageChecked, setPreviousPageChecked] = React.useState(false);
  const [insertCustomCodeChecked, setInsertCustomCodeChecked] = React.useState(false);
  const [error, setError] = React.useState(false);

  const [annotationName, setAnnotationName] = React.useState('');
  const [annotationType, setAnnotationType] = React.useState('none');
  const [newSelected, setNewSelected] = React.useState(false);
  const [attributeParam, setAttributeParam] = React.useState(['']);
  const [logicalOperatorParam, setLogicalOperatorParam] = React.useState(['']);
  const [comparisonOperatorParam, setComparisonOperatorParam] = React.useState(['']);
  const [valueParam, setValueParam] = React.useState(['']);
  const [entityName, setEntityName] = React.useState('');
  const [entity, setEntity] = React.useState('none');
  const [attributeType, setAttributeType] = React.useState('none');
  const [annotationValue, setAnnotationValue] = React.useState('none');
  const [annotationTable, setAnnotationTable] = React.useState(false);
  const [customAttributeType, setCustomAttributeType] = React.useState('');
  const [attributeTypeService, setAttributeTypeService] = React.useState('none');
  const [advanceSelectObject, setAdvanceSelectObject] = useState({ checked: false });
  const [isAdvanceSelect, setIsAdvanceSelect] = useState(advanceSelectObject.checked || false);
  const [annotationTarget, setAnnotationTarget] = useState(
    advanceSelectObject.optionAnnotationName || defaultOptionTarget
  );
  const [serviceSelectedAttr, setServiceSelectedAttr] = React.useState([]);
  const [queryParams, setQueryParams] = React.useState([]);
  const [headers, setHeaders] = React.useState([]);
  const [bodyParams, setBodyParams] = React.useState([]);
  const [defineServiceParam, setDefineServiceParam] = React.useState(false);
  const [connectedService, setConnectedService] = React.useState('none');
  const [paramType, setParamType] = React.useState('headers');
  const [requestParam, setRequestParam] = React.useState('none');
  const [entities, setEntities] = React.useState([]);
  const attributesTypes = [
    'text',
    'number',
    'password',
    'email',
    'image',
    'date',
    'checkbox',
    'radiobox',
    'entity',
    'service',
    'none'
  ];

  /**
   *
   */
  function checkForAdvancedSelect(grapeEditor, annType, attrType) {
    if (!grapeEditor) return false;
    const selectedElement = editor.getSelected();
    if (!selectedElement || selectedElement.attributes.tagName !== 'select') return false;
    if (!annType || !attrType || annType !== 'attribute' || attrType !== 'entity') return false;
    return true;
  }

  /*
    This useEffect is runned when we open the edit general pop up window of a component. It saves the page and updates the vars
    to start states.
    */
  useEffect(() => {
    if (clickedEdit === true && editor.getSelected() !== undefined) {
      setOpenAlert(true);
      setClickedEdit(false);
      setLock(false);
      // Save canvas on start
      savedPageClicked();
    }
  }, [clickedEdit]);

  useEffect(() => {
    if (
      checkForAdvancedSelect(editor, annotationType, attributeType) === false &&
      openAlert === true
    ) {
      setAdvanceSelectObject({ ...advanceSelectObject, checked: false });
      setIsAdvanceSelect(false);
    }
  }, [openAlert]);

  /*
    This useEffect is used to find all the violations during the proccess of giving annotation vars.Var lock is
    used to lock the update of the component if a violation exists.
  */
  useEffect(() => {
    findViolationsAnnotations(
      annotationName,
      annotationType,
      setLock,
      newSelected,
      entity,
      entityName,
      attributeType,
      customAttributeType,
      attributesTypes,
      entities,
      attributeTypeService,
      functionName,
      defineServiceParam,
      connectedService,
      requestParam,
      displayFlowData,
      href,
      hrefChecked,
      target,
      targetPageChecked
    );
  }, [
    annotationName,
    annotationType,
    entityName,
    newSelected,
    entity,
    customAttributeType,
    attributeType,
    attributeTypeService,
    functionName,
    defineServiceParam,
    connectedService,
    requestParam,
    displayFlowData,
    href,
    hrefChecked,
    target,
    targetPageChecked
  ]);

  /*
    This function is fired when clear all button next to annotation row title is clicked. It clears all the info that is used inside
    annotation component.
    */
  const clearAllAnnotations = () => {
    setAnnotationName('');
    setAnnotationType('none');
    setNewSelected(false);
    setEntity('none');
    setEntityName('');
    setAttributeType('none');
    setAttributeParam([]);
    setValueParam([]);
    setLogicalOperatorParam([]);
    setComparisonOperatorParam([]);
    setAnnotationValue('none');
    setAnnotationTable(false);
    setLock(false);
    setCustomAttributeType('');
    setAttributeTypeService('none');
    setFunctionName('none');
  };

  /*
    This function is fired when clear all button next to actions row title is clicked. It clears all the info that is used inside
    actions component.
  */
  const clearAllActions = () => {
    setTarget('none');
    setTargetPageChecked(false);
    setHref('');
    setHrefChecked(true);
    setNewWindowChecked(false);
    setTransitionById(false);
    setAdvanceSelectObject({ checked: false });
    setIsAdvanceSelect(false);
    setPreviousPageChecked(false);
    setInsertCustomCodeChecked(false);
    setDefineServiceParam(false);
    setConnectedService('none');
  };
  //

  /**
   *
   */
  function checkForAdvancedSelect2(grapeEditor) {
    //  debugger;
    if (!grapeEditor) return false;
    const selectedElement = editor.getSelected();
    if (
      !selectedElement ||
      selectedElement.attributes.tagName !== 'select' ||
      selectedElement.attributes.attributes.advanceselect2 !== 'true'
    )
      return false;
    return true;
  }
  return (
    <ServiceDialog
      open={openAlert}
      keepMounted
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
      id="editDataElementPopUp"
    >
      <div style={{ height: '100%' }}>
        {editor !== undefined &&
          editor.getSelected !== undefined &&
          editor.getSelected() !== undefined ? (
          <div className={clsx('titlePopUp', 'paddingTitle')}>
            {' '}
            Edit data element
            <div
              aria-hidden="true"
              onClick={() => {
                setError(false);
                setOpenAlert(false);
              }}
              className={clsx('pop-up-close-btn')}
            >
              x
            </div>
          </div>
        ) : null}
        <div
          className={clsx('paddingTitle')}
          style={{ height: '90%', overflowY: 'auto', maxHeight: '650px' }}
        >
          <div className={clsx('spacingTopDiv')}>
            <CheckActions
              label="Annotation"
              enableActions={displayAnnotationData}
              setEnableActions={setDisplayAnnotationData}
              clearAll={clearAllAnnotations}
            />
            <div
              className={clsx('spacingTopDiv', 'spacingLeftDiv', 'spacingRightDiv')}
              style={displayAnnotationData !== true ? { display: 'none' } : { display: 'inherit' }}
            >
              <AnnotationsMechanism
                clickedEdit={clickedEdit}
                editor={editor}
                setLock={setLock}
                selectedProject={selectedProject}
                annotationName={annotationName}
                setAnnotationName={setAnnotationName}
                annotationType={annotationType}
                setAnnotationType={setAnnotationType}
                newSelected={newSelected}
                setNewSelected={setNewSelected}
                attributeParam={attributeParam}
                setAttributeParam={setAttributeParam}
                valueParam={valueParam}
                setValueParam={setValueParam}
                logicalOperatorParam={logicalOperatorParam}
                setLogicalOperatorParam={setLogicalOperatorParam}
                comparisonOperatorParam={comparisonOperatorParam}
                setComparisonOperatorParam={setComparisonOperatorParam}
                entityName={entityName}
                setEntityName={setEntityName}
                entity={entity}
                setEntity={setEntity}
                attributeType={attributeType}
                setAttributeType={setAttributeType}
                annotationValue={annotationValue}
                setAnnotationValue={setAnnotationValue}
                annotationTable={annotationTable}
                setAnnotationTable={setAnnotationTable}
                customAttributeType={customAttributeType}
                setCustomAttributeType={setCustomAttributeType}
                attributeTypeService={attributeTypeService}
                setAttributeTypeService={setAttributeTypeService}
                functionName={functionName}
                setFunctionName={setFunctionName}
                serviceSelectedAttr={serviceSelectedAttr}
                setServiceSelectedAttr={setServiceSelectedAttr}
                queryParams={queryParams}
                setQueryParams={setQueryParams}
                headers={headers}
                setHeaders={setHeaders}
                bodyParams={bodyParams}
                setBodyParams={setBodyParams}
                setDisplayAnnotationData={setDisplayAnnotationData}
                attributesTypes={attributesTypes}
                entities={entities}
                setEntities={setEntities}
              />
            </div>
          </div>
          <div style={{ marginTop: '1vw' }}>
            <CheckActions
              label="Actions"
              enableActions={displayFlowData}
              setEnableActions={setDisplayFlowData}
              clearAll={clearAllActions}
            />
            <div
              className={clsx('spacingTopDiv', 'spacingLeftDiv', 'spacingRightDiv')}
              style={displayFlowData !== true ? { display: 'none' } : { display: 'inherit' }}
            >
              <FlowDataMechanism
                clickedEdit={clickedEdit}
                editor={editor}
                selectedProject={selectedProject}
                target={target}
                setTarget={setTarget}
                href={href}
                setHref={setHref}
                targetPageChecked={targetPageChecked}
                setTargetPageChecked={setTargetPageChecked}
                hrefChecked={hrefChecked}
                setHrefChecked={setHrefChecked}
                setDisplayFlowData={setDisplayFlowData}
                newWindowChecked={newWindowChecked}
                setNewWindowChecked={setNewWindowChecked}
                transitionById={transitionById}
                setTransitionById={setTransitionById}
                previousPageChecked={previousPageChecked}
                setPreviousPageChecked={setPreviousPageChecked}
                insertCustomCodeChecked={insertCustomCodeChecked}
                setInsertCustomCodeChecked={setInsertCustomCodeChecked}
                setOpenAlert={setOpenAlert}
              />
              {checkForAdvancedSelect(editor, annotationType, attributeType) && (
                <AdvancedSelect
                  openAlert={openAlert}
                  editor={editor}
                  annotationName={annotationName}
                  customAttributeType={customAttributeType}
                  selectedProject={selectedProject}
                  advanceSelectObject={advanceSelectObject}
                  setAdvanceSelectObject={setAdvanceSelectObject}
                  lock={lock}
                  setLock={setLock}
                  isAdvanceSelect={isAdvanceSelect}
                  setIsAdvanceSelect={setIsAdvanceSelect}
                  annotationTarget={annotationTarget}
                  setAnnotationTarget={setAnnotationTarget}
                  setDisplayFlowData={setDisplayFlowData}
                />
              )}
              {checkForAdvancedSelect2(editor, annotationType, attributeType) && (
                <AdvancedSelect2
                  annotationName={annotationName}
                  selectedProject={selectedProject}
                />
              )}
            </div>
            <DefineServiceParameter
              editor={editor}
              clickedEdit={clickedEdit}
              defineServiceParam={defineServiceParam}
              setDefineServiceParam={setDefineServiceParam}
              connectedService={connectedService}
              setConnectedService={setConnectedService}
              paramType={paramType}
              setParamType={setParamType}
              requestParam={requestParam}
              setRequestParam={setRequestParam}
            />
          </div>
          <FunctionsRow
            setOpenAlert={setOpenAlert}
            setClickedEdit={setClickedEdit}
            lock={lock}
            selectedProject={selectedProject}
            savedPageClicked={savedPageClicked}
            editor={editor}
            targetPageChecked={targetPageChecked}
            hrefChecked={hrefChecked}
            annotationName={annotationName}
            annotationType={annotationType}
            attributeType={attributeType}
            annotationValue={annotationValue}
            newSelected={newSelected}
            entity={entity}
            entityName={entityName}
            functionName={functionName}
            attributeParam={attributeParam}
            valueParam={valueParam}
            logicalOperatorParam={logicalOperatorParam}
            comparisonOperatorParam={comparisonOperatorParam}
            error={error}
            setError={setError}
            annotationTable={annotationTable}
            customAttributeType={customAttributeType}
            attributeTypeService={attributeTypeService}
            displayFlowData={displayFlowData}
            displayAnnotationData={displayAnnotationData}
            href={href}
            targetPage={target}
            newWindowChecked={newWindowChecked}
            advanceSelectObject={advanceSelectObject}
            transitionById={transitionById}
            isAdvanceSelect={isAdvanceSelect}
            annotationTarget={annotationTarget}
            previousPageChecked={previousPageChecked}
            insertCustomCodeChecked={insertCustomCodeChecked}
            serviceSelectedAttr={serviceSelectedAttr}
            headers={headers}
            bodyParams={bodyParams}
            queryParams={queryParams}
            connectedService={connectedService}
            paramType={paramType}
            requestParam={requestParam}
            defineServiceParam={defineServiceParam}
          />
        </div>
      </div>
    </ServiceDialog>
  );
};

export default EditPopUpCore;
